var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLaundryMachine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2696 2.23691H4.0361C3.30396 2.23691 2.71045 2.83042 2.71045 3.56256V20.796C2.71045 21.5281 3.30396 22.1217 4.0361 22.1217H21.2696C22.0017 22.1217 22.5952 21.5281 22.5952 20.796V3.56256C22.5952 2.83042 22.0017 2.23691 21.2696 2.23691Z",
    stroke: "#8A8A8A",
    strokeWidth: 1.32565,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6527 19.4705C15.9473 19.4705 18.6181 16.7997 18.6181 13.5051C18.6181 10.2105 15.9473 7.53964 12.6527 7.53964C9.35807 7.53964 6.68726 10.2105 6.68726 13.5051C6.68726 16.7997 9.35807 19.4705 12.6527 19.4705Z",
    stroke: "#8A8A8A",
    strokeWidth: 1.32565,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5952 7.53961H18.8701C18.066 6.70145 17.1007 6.03453 16.0323 5.57894C14.9639 5.12335 13.8144 4.88849 12.6528 4.88849C11.4913 4.88849 10.3418 5.12335 9.27336 5.57894C8.20493 6.03453 7.23964 6.70145 6.43553 7.53961H2.71045",
    stroke: "#8A8A8A",
    strokeWidth: 1.32565,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9437 5.21965C19.7607 5.21965 19.6123 5.07127 19.6123 4.88824C19.6123 4.7052 19.7607 4.55682 19.9437 4.55682",
    stroke: "#8A8A8A",
    strokeWidth: 1.32565
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9438 5.21965C20.1269 5.21965 20.2753 5.07127 20.2753 4.88824C20.2753 4.7052 20.1269 4.55682 19.9438 4.55682",
    stroke: "#8A8A8A",
    strokeWidth: 1.32565
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6528 16.8191C14.4831 16.8191 15.9669 15.3353 15.9669 13.505C15.9669 11.6746 14.4831 10.1908 12.6528 10.1908C10.8224 10.1908 9.33862 11.6746 9.33862 13.505C9.33862 15.3353 10.8224 16.8191 12.6528 16.8191Z",
    stroke: "#8A8A8A",
    strokeWidth: 1.32565,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaundryMachine);
export default __webpack_public_path__ + "static/media/laundry-machine.a188cb333a55c3971869a6e1a0991afa.svg";
export { ForwardRef as ReactComponent };